/* eslint-disable import/no-unresolved */
import { useLocation } from 'react-router-dom';
import { Button, Container, FormControlLabel, Switch } from '@material-ui/core';
import CreateClientForm from 'src/components/_dashboard/client/CreateClientForm';
import ClientList from 'src/components/_dashboard/client/ClientList';

// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function QA() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  // const { name } = useParams();
  // const { userList } = useSelector((state) => state.user);
  const isEdit = pathname.includes('edit');
  // const currentUser = userList.find((user) => paramCase(user.name) === name);

  return (
    <Page title="QA | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Omni Channel"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'QA', href: PATH_DASHBOARD.general.qa },
            { name: 'QA view' }
          ]}
        />
      </Container>
    </Page>
  );
}
